import { useMutation, useQueryClient } from '@tanstack/react-query';
import { IntegratedPropertyUpdate } from '@acp/shared';
import { updateIntegratedProperty } from '../service';

function useUpdateIntegratedProperty(
    agencyPortfolioPropertyId: number,
    {
        onSuccess = () => {},
    }: {
        onSuccess: () => void;
    }
) {
    const queryClient = useQueryClient();
    const query = useMutation({
        mutationFn: (payload: IntegratedPropertyUpdate) => updateIntegratedProperty(
            agencyPortfolioPropertyId,
            payload
        ),
        onSuccess: () => {
            void queryClient.invalidateQueries({
                queryKey: ['non-managed-property', agencyPortfolioPropertyId],
            });

            void queryClient.invalidateQueries({
                queryKey: ['integrated-properties'],
            });

            void queryClient.invalidateQueries({
                queryKey: ['stats', 'non-managed'],
            });

            onSuccess();
        },
    });

    return query;
}

export { useUpdateIntegratedProperty };
